import styled from "styled-components";
import { Link as LinkS } from "react-scroll";
import { Link as LinkR } from "react-router-dom";

export const Button = styled(LinkS)`
  display: ${({ visible }) => (visible ? "none" : "flex")};
  border-radius: 50px;
  background: ${({ primary }) => (primary ? "#FA9905" : "#010606")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px" : "12px 30px")};
  color: ${({ dark }) => (dark ? "#010606" : "#fff")};
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? "#fff" : "#FA9905")};
  }
`;

export const ButtonR = styled(LinkR)`
  display: ${({ visible }) => (visible ? "none" : "flex")};
  border-radius: 50px;
  background: ${({ primary }) => (primary ? "#FA9905" : "#010606")};
  white-space: nowrap;
  padding: ${({ big }) => (big ? "14px" : "12px 30px")};
  color: #010606;
  font-size: ${({ fontBig }) => (fontBig ? "20px" : "16px")};
  outline: none;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: ${({ primary }) => (primary ? "#fff" : "#FA9905")};
  }
`;
